import { get, post } from '../api';

const fields = '_id terms accommodates title beds bedrooms bathrooms propertyType address.full address.city address.country address.state address.street address.lng address.lat publicDescription picture.regular picture.large defaultCheckInTime defaultCheckOutTime prices.extraPersonFee prices.weeklyPriceFactor prices.monthlyPriceFactor amenities pictures';

export function getListings(options = {}) {
  const params = {
    active: true,
    listed: true,
    fields,
    skip: options.skip
  };

  if (options.city) {
    params.filters = (JSON.stringify([{ field: "address.city", operator: "$eq", value: options.city }]));
  }

  if (options.startDate && options.endDate) {
    params.available = {
      checkIn: options.startDate,
      checkOut: options.endDate,
      minOccupancy: options.guests || 1
    };
  }

  return get('/listings', params);
}

export function getCities() {
  return get('/listings/cities');
}

export function getListingCalendar(listingId, from, to) {
  return get(`/listings/${listingId}/calendar`, { from, to });
}

export function getSingleListing(listingId, from, to) {
  return get(`/listings/${listingId}`, {
    fields,
    available: {
      checkIn: from,
      checkOut: to,
      minOccupancy: 1
    }
  });
}

export function postBooking(data) {
  return post('/reservations/create', data);
}


// WEBPACK FOOTER //
// ./src/listing/listing.service.js